import {
  RcfaComplianceTableData,
  RcfaComplianceLocationNode,
  RcfaComplianceLocationNodeDto,
  RcfaComplianceLocationType
} from '@domain/rcfa'
import {HierarchyNodeType} from '@domain/shared'
import {traverseWithKey} from '@hconnect/common/utils'
import {orderBy} from 'lodash'

export const mapToRcfaComplianceHierarchyTable = (
  stats: RcfaComplianceLocationNode[]
): RcfaComplianceTableData[] => {
  return stats.map(({id, type, name, rcfaCompliance, countryCode, subLocations}) => ({
    id,
    type,
    name,
    rcfaCompliance,
    countryCode: type !== HierarchyNodeType.Plant ? countryCode : undefined,
    subItems: mapToRcfaComplianceHierarchyTable(subLocations)
  }))
}

const locationTypeToHierarchyNodeType: Record<RcfaComplianceLocationType, HierarchyNodeType> = {
  Global: HierarchyNodeType.Global,
  ManagementArea: HierarchyNodeType.Area,
  Region: HierarchyNodeType.Region,
  Country: HierarchyNodeType.Country,
  Plant: HierarchyNodeType.Plant
}

export const convertToLocationNodes = (
  data: RcfaComplianceLocationNodeDto
): RcfaComplianceLocationNode[] => data.children.map(convertToLocationNode)

export const convertToLocationNode = (
  dto: RcfaComplianceLocationNodeDto
): RcfaComplianceLocationNode => ({
  id: dto.id,
  name: dto.name,
  type: locationTypeToHierarchyNodeType[dto.type],
  rcfaCompliance: dto.rcfaCompliance,
  subLocations: dto.children.map(convertToLocationNode),
  countryCode: dto.countryCode
})

export const mapToRcfaCompliancePlantList = (
  statsList: RcfaComplianceLocationNode[]
): RcfaComplianceTableData[] => {
  const result: RcfaComplianceTableData[] = []

  traverseNodes(statsList, (stats: RcfaComplianceLocationNode) => {
    const {id, name, type, countryCode, rcfaCompliance} = stats
    if (type === HierarchyNodeType.Plant) {
      result.push({
        id,
        name,
        type,
        countryCode,
        rcfaCompliance,
        subItems: []
      })
    }
  })

  return orderBy(result, ['name'], ['asc'])
}

const traverseNodes = (
  nodes: RcfaComplianceLocationNode[],
  op: (node: RcfaComplianceLocationNode) => void
) => traverseWithKey('subLocations', nodes, op)
